import { matchPath } from 'react-router-dom'

export default function useParams(history, path) {
  const match = matchPath(history.location.pathname, { path })  
  return (match && match.params) || {}
}


// WEBPACK FOOTER //
// ./src/shared/utils/useParams.js